// extracted by mini-css-extract-plugin
export var center = "_5c-2";
export var clickableRow = "_5c-5";
export var expandedRow = "_5c-7";
export var hoverable = "_5c-4";
export var left = "_5c-1";
export var right = "_5c-3";
export var row = "_5c-0";
export var selectedRow = "_5c-6";
export var summaryRow = "_5c-8";